import styled from 'styled-components'
import { Button, Tooltip } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { CaffeinePressableList, StepsHeader } from '../../components'
import { useOnboarding } from '../../contexts/OnboardingContext'
import { useTranslation } from "react-i18next"

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`

const CaffeineContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 32px;
`

const CaffeineOptionsContainer = styled.div`
  padding-top: 12px;
  margin: 24px 0 24px 0;
  overflow-y: scroll;

  @media screen and (min-height: 1024px) {
    max-height: 65vh;
  }

  @media screen and (max-height: 1024px) {
    max-height: 60vh;
  }

  @media screen and (max-height: 860px) {
    max-height: 50vh;
  }

  @media screen and (max-height: 768px) {
    max-height: 42vh;
  }
`

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  position: fixed;
  height: 36px;
  bottom: 44px;
  left: 44px;
  right: 44px;
  margin-bottom: 0px;
`

const CaffeineType = ({ onNext, onPrevious }) => {
  const {
    caffeineProducts,
    selectedCaffeineOptions,
    setSelectedCaffeineOptions,
  } = useOnboarding()

  const { t } = useTranslation('common')

  return (
    <Container>
      <div>
        <StepsHeader
          stepText={t('onboarding.four_steps.three')}
          description={t('onboarding.caffeine.type.description')}
        />

        <CaffeineContainer>
          <span style={{ fontSize: 24, fontWeight: 700, textAlign: 'center' }}>
            {t('onboarding.caffeine.type.question')}
          </span>
          <span style={{ fontSize: 18, textAlign: 'center' }}>
            {t('onboarding.caffeine.type.input_request')}
          </span>
          <CaffeineOptionsContainer>
            <CaffeinePressableList
              caffeineProducts={caffeineProducts}
              selectedOptions={selectedCaffeineOptions}
              onSelectOption={setSelectedCaffeineOptions}
            />
          </CaffeineOptionsContainer>
        </CaffeineContainer>
      </div>
      <Footer>
        <Button
          variant='text'
          onClick={onPrevious}
          startIcon={<ArrowBackIcon />}
        >
          {t('onboarding.return')}
        </Button>
        {selectedCaffeineOptions.length <= 0 ? (
          <Tooltip
            title={t('onboarding.caffeine.type.tooltip')}
            placement='top'
            arrow
          >
            <span>
              <Button
                variant='contained'
                disabled
              >
                {t('onboarding.advance')}
              </Button>
            </span>
          </Tooltip>
        ) : (
          <Button
            variant='contained'
            onClick={
              selectedCaffeineOptions[0]?.isNoCaffeine
                ? () => {
                    onNext()
                    onNext()
                  }
                : onNext
            }
          >
            {t('onboarding.advance')}
          </Button>
        )}
      </Footer>
    </Container>
  )
}

export default CaffeineType
